var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloseButton = function SvgIconCloseButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#fff",
    rx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M12.595 21.341a1.458 1.458 0 1 0 2.062 2.063l3.344-3.344 3.344 3.344a1.458 1.458 0 1 0 2.063-2.063l-3.344-3.344 3.343-3.343a1.458 1.458 0 1 0-2.062-2.063l-3.344 3.344-3.343-3.344a1.458 1.458 0 0 0-2.063 2.063l3.344 3.343z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCloseButton;